import type { FunctionReturnType } from "convex/server";
import type { api } from "../lib/api";
import { workbookXlsxBytes, type SpreadsheetSheet } from "./xlsx";

type Coverage = NonNullable<FunctionReturnType<typeof api.complianceProjects.coverage>>;
export function projectCoverageSheets(data: Coverage): SpreadsheetSheet[] {
  return [
    { name: "Project Summary", rows: [["Field", "Value"], ["Project", data.project.name],
      ["Status", data.project.status], ["Description", data.project.description ?? ""],
      ["Lead user ID", data.project.projectLeadUserId ?? "Unassigned"],
      ["Due date", data.project.dueAt == null ? "" : new Date(data.project.dueAt).toISOString().slice(0, 10)], ["Mappings", data.mappings.length],
      ["Human verified", data.mappings.filter(m => m.verificationStatus === "humanVerified").length],
      ["Scope", data.project.businessScopeId == null ? "All company mappings" : "Company-wide and matching business-area mappings"]] },
    { name: "Obligation Coverage", rows: [["Legislation", "Clause", "Obligation", "Document", "Document location", "Coverage", "Compliance", "Verification", "Assessment", "Gap", "Action", "Source status"],
      ...data.mappings.map(m => [m.legislationTitle, m.obligationSection, m.obligationText, m.documentTitle, m.policyLocation,
        m.coverageStatus, m.complianceStatus ?? "notMapped", m.verificationStatus, m.rationale, m.gap, m.recommendedAction,
        m.historical ? "Historical snapshot; current status unverified" : "Lawstream content"])] },
    { name: "About", rows: [["Field", "Value"], ["Schema", "lawstream.project-compliance.v1"],
      ["Project ID", data.project._id], ["Generated", new Date().toISOString()],
      ["Ratings", "Compliance and human verification are separate assessments. Archived tasks are excluded."]] },
  ];
}
export const projectCoverageBytes = (data: Coverage): Uint8Array => workbookXlsxBytes(projectCoverageSheets(data));
